import { MutableRefObject,useEffect } from 'react'
import { onNextTick } from 'utils'
import { isNilOrEmpty } from 'utils'

/**
 *
 * @param ref - ref object
 * @param shouldFocus - optional boolean
 * This hook is used to force focus on an element without applying the focus outline
 * styles as defined in utils/styles.ts
 *
 * Mainly used for accessibility/screen readers
 */

export default function useForceFocus(
  ref: MutableRefObject<any>,
  shouldFocus: boolean = true
  ) {
    useEffect(() => {
      let $ref = ref?.current ?? null

    if (isNilOrEmpty($ref)) {
      return
    }

    if (shouldFocus) {
      onNextTick(() => {
          setTimeout(() => {
            $ref.focus()
            $ref.classList.remove('focus-visible')
          }, 100)
        })
      } else {
        onNextTick(() => $ref.blur())
      }

      return () => {
        $ref?.blur()
      }
  }, [ref, shouldFocus])
}
